import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getLightBorder } from 'Components/utils';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('MessageDate', (theme) => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2, 0, 2, 0),
    marginBottom: theme.spacing(2),
  },
  line: {
    height: 1,
    flexGrow: 1,
    ...getLightBorder(theme, { top: true }),
  },
  date: {
    padding: theme.spacing(0, 2.5),
  },
}));

const MessageDate = ({
  date,
}) => {
  const classes = useStyles();

  return (
    <Paper
      className={classes.root}
      elevation={0}
      {...DataValueMap.init('message-date-separator')
        .build()}
    >
      <Box className={classes.line} />
      <Typography
        className={classes.date}
        variant="h5"
        color="black"
        weight={'medium'}
      >
        {date.format('LL')}
      </Typography>
      <Box className={classes.line} />
    </Paper>
  );
};

MessageDate.propTypes = {
  date: PropTypes.object.isRequired,
};

export default MessageDate;
